import React, { forwardRef } from "react";
import { default as _DatePicker, registerLocale } from "react-datepicker";
import { useApp } from 'common/AppContext';

import { es, zhCN, fr } from 'date-fns/locale';
import classNames from "classnames";

import "react-datepicker/dist/react-datepicker.css";
import "./styles/DatePicker.css";

registerLocale('es-MX', es);
registerLocale('zh-CN', zhCN);
registerLocale('fr-FR', fr);

export const DatePicker = forwardRef(({ className, ...props }, forwardedRef) => {
    const { locale } = useApp();
    const combinedClassName = classNames(className, 'form-control');
    return (
        <_DatePicker ref={forwardedRef} className={combinedClassName} locale={locale} {...props}/>
    );
});

DatePicker.displayName = 'DatePicker';

DatePicker.defaultProps = _DatePicker.defaultProps;

export default DatePicker;